__turbopack_context__.v({
  "className": "libre_baskerville_4806155-module__03sbSW__className",
});
